import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import _ from 'lodash';
import {CustomFieldOption} from 'main/stores/custom_fields';

class EmployeeCustomField extends DomainObject {
  id;
  value;
  type;
  name;
  description;
  required;
  category;
  options = [];
  customFieldGroupId;
  createdAt;
  order;

  _relations = {
    options: [CustomFieldOption],
    type: oneOf(['text_field', 'text_area', 'date', 'number', 'multiple_choice']),
    _dates: this.type === 'date' ? ['value'] : []
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      value: observable,
      type: observable,
      name: observable,
      description: observable,
      required: observable,
      category: observable,
      options: observable,
      customFieldGroupId: observable,
      createdAt: observable,
      order: observable,
      sortedOptions: computed,
      isDate: computed
    });

    this.merge(other);
  }

  get sortedOptions() {
    return _.sortBy(this.options, 'id');
  }

  get isDate() {
    return this.type === 'date';
  }
}

export default EmployeeCustomField;
